<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="refundType" :translate-params="{id: refundType.id, code: refundType.code}">
        Edit Refund Type #%{id} - %{code}
      </translate>
    </h1>
    <RefundTypeForm :data="refundType" @save="onSave" :save_text="$pgettext('form', 'Save')"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import RefundTypeForm from "@/domain/refundType/components/RefundTypeForm.vue";

export default {
  name: 'EditRefundType',
  components: {RefundTypeForm},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await this.fetchRefundType(this.$route.params.id)
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'refundType.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('refundType', ['refundType']),
  },
  methods: {
    ...mapActions('refundType', ['fetchRefundType', 'updateRefundType']),

    async onSave(data) {
      await this.updateRefundType({id: this.refundType.id, data: data})
      await this.$router.push({name: 'refundType.list'})
      throw new SuccessNotification(this.$pgettext('refundType', 'Refund type updated!'))
    }
  }
}
</script>
